export interface IQuotationVO {
  campaigns: any[]; // TODO Define the type of campaigns if known
  discount: number;
  serviceId: number;
  service: string;
  isPickupDelivery: boolean;
  isInitialQuotation?: string;
  isApproved: string;
  dmsCode: string;
  price: number;
  costless: boolean;
}

export interface IQuotationScheduleVO {
  quotationVOs: IQuotationVO[];
}

export interface IConfigSchedule {
  scheduleDate: string; // ISO date string
  scheduleHour: number; // Represented in minutes from midnight
  advisor: number;
  scheduleModality: string;
  division: number;
  country: string;
  scheduleSource: string;
  scheduleType: string;
  createS: string; // ISO date string
  sendEmail: boolean;
  dealer: number;
}

export interface IVehicleSchedule {
  vin: string;
  vehiclePlate: string;
  model: string;
  group?: number;
}

export interface IUserSchedule {
  customerRemark: string;
  customerId: string;
  contactCustomerId: string;
  createUser: string;
  scheduleUser: string;
}

export interface ISchedulePayload extends IConfigSchedule, IVehicleSchedule, IUserSchedule {
  quotationScheduleVO: IQuotationScheduleVO;
  offeredServices: number[];
}
